import { Component, OnInit, EventEmitter, Output, TemplateRef, ViewChild, ElementRef, Renderer2, ViewChildren, QueryList, ChangeDetectorRef, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettingService } from '../services/settingService/setting.service';
import * as jwt_decode from 'jwt-decode';
import { AddSubFolderVM } from 'src/app/viewModels/core/add-sub-folder-vm';
import { CommonService } from 'src/app/middleware/common/common.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { Observable, Subscription } from 'rxjs';
import { AddFieldsVM, ReorderPositionVm, AddEditGroupVm } from 'src/app/viewModels/core/add-fields-vm';
import { CdkDragDrop, CdkDrag, CdkDropList, moveItemInArray, transferArrayItem, CdkDragEnter, CdkDragExit, CdkDragStart } from '@angular/cdk/drag-drop';
import { asapScheduler, asyncScheduler } from 'rxjs';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { RoleLevel } from '../services/settingService/setting.enum';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { MatCheckboxChange } from '@angular/material/checkbox';

export interface Row {
  organizationName: string,
  organizationType: string,
  database: string,
  representativePerson:string,
  email:string,
  phone:string,
  offices?:Row[]
}

export const ROWS: Row[] = [
  {
    organizationName: "Standford Medical Center",
    organizationType: "Health Care",
    database: "Dedicated",
    representativePerson: "Matt Mcalpin",
    email:"matt@gmail.com",
    phone:"9876743825",
  },
  {
    organizationName: "Green Care",
    organizationType: "Surgery Center",
    database: "Shared",
    representativePerson: "Matt Mcalpin",
    email:"matt@gmail.com",
    phone:"9876743825",
    offices: [
      {
        organizationName: "GK",
        organizationType: "Legal",
        database: "Shared",
        representativePerson: "Matt Mcalpin",
        email:"matt@gmail.com",
        phone:"9876743825",
      },
      {
        organizationName: "WTO",
        organizationType: "Education",
        database: "Dedicated",
        representativePerson: "Matt Mcalpin",
        email:"matt@gmail.com",
        phone:"9876743825",
      },
    ]
  },
  {
    organizationName: "European Central",
    organizationType: "Hospital",
    database: "Shared",
    representativePerson: "Matt Mcalpin",
    email:"matt@gmail.com",
    phone:"9876743825",
  },
  {
    organizationName: "World Trade",
    organizationType: "Doctor",
    database: "Dedicated",
    representativePerson: "Matt Mcalpin",
    email:"matt@gmail.com",
    phone:"9876743825",
    offices: [
      {
        organizationName: "ILO",
        organizationType: "Real Estate",
        database: "Shared",
        representativePerson: "Matt Mcalpin",
        email:"matt@gmail.com",
        phone:"9876743825",
      },
      {
        organizationName: "ICRC",
        organizationType: "Legal",
        database: "Dedicated",
        representativePerson: "Matt Mcalpin",
        email:"matt@gmail.com",
        phone:"9876743825",
      },
    ]
  },
];

@Component({
  selector: 'app-people',
  templateUrl: './people.component.html',
  styleUrls: ['./people.component.scss'],
   animations: [
      trigger('detailExpand', [
        state('collapsed', style({ height: '0px', minHeight: '0', overflow:'hidden'})),
        state('expanded', style({height: '*'})),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      ]),
    ],
})



export class PeopleComponent implements OnInit {
  expanded: {[key: string]: boolean} = {};
  rows = ROWS;

  @ViewChildren(CdkDropList)
  private dlq: QueryList<CdkDropList>;
  public dls: CdkDropList[] = [];
  createfilledSlide: boolean = true;
  editfilledSlide: boolean = true;
  databaseId: string;
  organizationId: string;

  currentUser: any;
  subscriptionPeopleList: any;
  folderDetail: any;
  folderId: any;
  _value: any;
  getSubFolderListResponseHolder: any;
  getFieldsListResponseHolder: any;
  showSidePanel: boolean = false;
  subFolderList: any[] = [];
  subFolderListCheck: any[] = [];
  selectedItems: any;
  getFieldModel = {
    userID: "",
    organizationID: 0,
    databaseID: 0,
    folderID: 0,
    subFolderID: 0,
    fieldID: 0,
    OfficeIDList:[],
    officeID:0
  };
  fieldsList: any[] = [];
  DeactivatefieldsList: any[] = [];
  fieldListFolderWise: any[] = [];
  fieldListGroupWise: any[] = [];
  deleteModel = {
    databaseID: 0,
    userID: "",
    fieldID: 0,
    fieldFolderType: 0,
    OfficeIDList:[],
    officeID:0
  };
  fieldData: any[] = [];
  ReorderPositionModel = {
    folderID: 0,
    userID: "",
    databaseID: 0,
    organizationID: 0,
    fieldGroupID: 0,
    isRemove: false,
  };

  FieldGroupID: number;

  deactivateModel = {
    userID: "",
    organizationID: 0,
    databaseID: 0,
    fieldID: 0,
    folderID: 0,
    subFolderID: 0,
    isActive: true,
    isRequired: true,
    requestType: 0,
    OfficeIDList:[],
    officeID:0
  };

  EditGroupModel = {
    fieldGroupID: 0,
    groupName: "",
    organizationID: 0,
    folderID: 0,
    OfficeIDList:[],
    officeID:0
  }

  updateModel = {
    userID: "",
    databaseID: 0,
    fieldName: "",
    fieldTypeID: 0,
    fieldTypeName: "",
    folderID: 0,
    folderName: "",
    position: 0,
    defaultValue: "",
    isRequired: false,
    isRemove: false,
    isDeactivated: false,
    fieldFolderType: 0,
    placeholder: "",
    fieldID: 0,
    organizationID: 0,
    fieldGroupID: 0,
    OfficeIDList:[],
    officeID:0
  }
  deactivateResponseHolder: any;
  deleteResponseHolder: any;
  subFolderName: any;
  createSubFolderModel = {
    userID: "",
    folderName: "",
    parentID: 0,
    databaseID: 0,
    folderType: 1,
    organizationID: 0,
    OfficeIDList:[],
    officeID:0
  };
  getSubFolderFieldsModel = {
    databaseID: 0,
    userID: "",
    folderID: 0,
    organizationID: 0,
    subFolderID: 0,
    fieldID: 0,
    OfficeIDList:[],
    officeID:0
  };
  subFolderID:number= 0;
  createSubFolderResponseHolder: any;
  dragdata: any;
  getSubFolderFieldsListResponseHolder: any;
  subFolderFieldsList: any[] = [];
  showeditForm: boolean = false;
  updateFieldResponseHolder: any;
  newPosition: any;
  showEditPanel: boolean = false;
  showAdditionalField: boolean = false;
  expandAdditionalField: boolean = false;
  fieldFolderType: any;
  expandedIndex: any;
  clickEventsubscription: Subscription;
  typename:string;
  folderName:string;

  @Output() openSlide = new EventEmitter<boolean>();
  @Output() showRole = new EventEmitter<boolean>();
  @Output() openEditSlide = new EventEmitter<boolean>();
  @ViewChild('secondDialog') secondDialog: TemplateRef<any>;
  OfficeIDList: any[] = [];
  myOfficeID: any;
  permissionAsssign: any[] = [];

  @ViewChild('groupField') groupField: ElementRef;
  isNavbarFixed: boolean = false;

  form: FormGroup;
  rolesAsssign: any[] = [];
  SuperAdminAdd:boolean=false;
  officeAdmin:boolean=false;
  constructor(private dialog: MatDialog, private formBuilder: FormBuilder,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private statusConst: StatusConstant, private loaderService: LoaderService,
    private toastr: ToastrService, private router: Router,
    private settingsService: SettingService, private addSubFolderVM: AddSubFolderVM,
    private commonService: CommonService,private reorderPositionVm: ReorderPositionVm,
    private addEditGroupVm: AddEditGroupVm, private el: ElementRef, private renderer: Renderer2,
    private change: ChangeDetectorRef,private _dataSharingService: DataSharingService,
    private ele: ElementRef
    ) {
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
      });
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    this.folderDetail = this.commonService.getEditData();
    this.folderId = this.folderDetail.folderID;
    this.folderName = this.folderDetail.orgModuleName;//this.folderDetail.folderName;
  }

  ngOnDestroy() {
    if (this.clickEventsubscription) {
      this.clickEventsubscription.unsubscribe();
    }
    if (this.subscriptionPeopleList) {
      this.subscriptionPeopleList.unsubscribe();
    }
  }

  ngOnInit(): void {
    // this.form = this.formBuilder.group({
    //   rows: this.formBuilder.array([])
    // });
    
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    if(this.rolesAsssign.length > 0){
      var Superadmin=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      Superadmin= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);
      if(Superadmin.length > 0){
        this.SuperAdminAdd=true;
        //return;
      }else{
        this.SuperAdminAdd=false;
      } 
      
           var roleOfficeAdmin=[];
             // roleLevel:1 (Super admin), roleLevel:2 (Organization Admin), roleLevel:3 (Office Admin),
             // roleLevel:11 (User)
            
           roleOfficeAdmin= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OfficeAdmin);
           if(roleOfficeAdmin.length > 0){        
            this.officeAdmin=true;            
           } 
      
            var roleOrgAdmin=[];
            roleOrgAdmin= this.rolesAsssign.filter((m) => m.roleLevel ==  RoleLevel.OrganizationAdmin);
            if(roleOrgAdmin.length > 0){            
             this.officeAdmin=false;
           }
    } 
    this.permissionAsssign = JSON.parse(sessionStorage.getItem("menuModules"));
    this.permissionAsssign =this.permissionAsssign.filter((x) => x.mainModuleName == 'Settings' && x.isAssign==true);
    if(this.permissionAsssign.length == 0){
      this.router.navigate(['unauthorised']);
      return;
    }

    this.getSubFolderList();
    this.getSubFolderListForDuplicate();
    this.getAllFields(this.subFolderID);
    this.subscriptionPeopleList = this.commonService.loadPeopleList.subscribe(response => {
      this._value = response;
      if (this._value) {
        this.getAllFields(this.subFolderID);
        this.commonService.listRefreshPeople.next(false);
      }
    });

    this.typename =this.folderName;
    this.clickEventsubscription = this._dataSharingService.getClickEventforfields().subscribe(() => {
      this.getSubFolderList();
      this.getSubFolderListForDuplicate();
      this.getAllFields(this.subFolderID);
    });
  }

  // @HostListener('window:scroll', ['$event']) onScroll() {
  //   if (window.scrollY > 100) {
  //     this.isNavbarFixed = true;
  //   } else {
  //     this.isNavbarFixed = false;
  //   }
  // }

  selectedGroup: any

  showSubGroup(className: string,item:any){
    let name = className
    let element = this.ele.nativeElement.querySelectorAll(".group"+name)
    let isExist = element[0].classList.contains("showGroup")
    if(!isExist){
      element[0].classList.add('showGroup')
    }else{
      element[0].classList.remove('showGroup')
    }

    let field = this.ele.nativeElement.querySelectorAll(".f"+name)
    let fieldActive = field[0].classList.contains("active")
    if(!fieldActive){
      field[0].classList.add('active')
    }else{
      field[0].classList.remove('active')
    }
  }

  ngAfterViewInit() {
    this.refreshDLS();
  }

  refreshDLS() {
    let ldls: CdkDropList[] = [];
    this.dlq.forEach((dl) => {
      ldls.push(dl)
    });
    ldls = ldls.reverse();
    asapScheduler.schedule(() => { this.dls = ldls; });
  }

  getAllFields(subFolderID) {
    this.getFieldModel.databaseID = Number(this.databaseId);
    this.getFieldModel.organizationID = Number(this.organizationId);
    this.getFieldModel.userID = this.currentUser.UID;
    this.getFieldModel.folderID = this.folderId;
    this.getFieldModel.subFolderID = subFolderID;//0;
    this.getFieldModel.fieldID = 0;
    this.getFieldModel.OfficeIDList=this.OfficeIDList;
    this.getFieldModel.officeID=this.myOfficeID;
    this.loaderService.show();
    this.settingsService.getAllFieldsCore(this.getFieldModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getFieldsListResponseHolder = response;
        if (this.getFieldsListResponseHolder.status == this.statusConst.statusSuccess) {
          this.fieldsList = this.getFieldsListResponseHolder.data.activeFields;//.filter(s => s.isActive == true);
          this.fieldsList = this.fieldsList.filter(s => s.fieldTypeName != 'Image');
          this.DeactivatefieldsList = this.getFieldsListResponseHolder.data.inActiveFields;//.filter(s => s.isActive == false);
          this.fieldListFolderWise = this.fieldsList;
          this.drapDropList = this.displayDragAndDropList(this.fieldListFolderWise);
          this.change.detectChanges();
          this.refreshDLS();
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }


  drapDropList = [];
  dragDropHolderList=[];
  displayDragAndDropList(list: any[]): any[] {
    var _list: any[] = list.map(s => Object.assign(s));
    var returnList: any[] = [];
    _list.forEach(s => {
      if (s.fieldID == 0) {
        var childList: any[] = [];
        s.data.forEach((c: { groupName: any; FieldGroupID: any; }) => {
          c.groupName = s.data[0].groupName,
            c.FieldGroupID = s.data[0].fieldGroupID,
            childList.push(c);
        });
        returnList.push(childList);
      } else {
        returnList.push(s);
      }
    });
    return returnList;
  }


  Reorder(event: { container: { data: any[]; }; currentIndex: number; previousIndex: number; previousContainer: { data: { [x: string]: any; }; }; },reorderedFieldArray:any) {
    var getData = this.dragdata;
    var DropIndexData = event.container.data[event.currentIndex];
    if(DropIndexData == undefined){
      DropIndexData = event.container.data[event.currentIndex -1];
    }
    var fieldGroupID = 0;
    var fieldID = 0;
    var currentindex =0;
    var previousindex =0;
    var isRemove =false;
    var isGroupMove =false;
    if(getData !=undefined) {
      previousindex = getData.position;
    }
    if(DropIndexData != undefined && DropIndexData.FieldGroupID > 0  && DropIndexData.FieldGroupID!=undefined ) {
      fieldID = DropIndexData.fieldID;
      if(getData == undefined || getData == null) {
        fieldGroupID = 0;

         var currentindexx = event.container.data[event.currentIndex];
         var previousindexx = event.container.data[event.previousIndex];

         if(previousindexx == undefined){
          fieldID = 0;//previousindexx.fieldID;
          fieldGroupID =DropIndexData.FieldGroupID;
         }
         else{
          fieldID = previousindexx.fieldID;
          fieldGroupID =DropIndexData.FieldGroupID;
         }

         if(event.currentIndex == 1){
          currentindex = 0;
         }
         else{
          currentindex =currentindexx.position;
         }

         previousindex = previousindexx.position;
      }
      else{
        currentindex = DropIndexData.position;
        fieldGroupID = DropIndexData.FieldGroupID;
        fieldID= getData.fieldID;//DropIndexData.fieldID;
      }
    }
    else {
      if(DropIndexData.length > 1 && DropIndexData !=undefined) {
        var data = DropIndexData[event.previousIndex];
        currentindex =event.currentIndex;
        if(data == undefined){
         previousindexx =event.container.data[event.previousIndex]; //event.previousIndex;
         previousindex= previousindexx.position;
        }else {
          previousindex = data.position;
          isRemove =true;
        }
      }
      else{
        currentindex = (DropIndexData.position); //event.currentIndex;//DropIndexData.position;
        if(currentindex == 0){
          currentindex = 1;
        }
        if(currentindex == undefined || currentindex < 0) {
          currentindex = 0;//event.currentIndex;
        }
        previousindexx =event.previousContainer.data[event.previousIndex];
        if(previousindexx.length >= 1){
          previousindexx =event.previousContainer.data[event.previousIndex];
          previousindex = previousindexx[0].position;
          fieldGroupID = previousindexx[0].fieldGroupID;
          isGroupMove =true;
        } else {
          previousindex = previousindexx.position;
          fieldGroupID = 0;
        }
      }

      if(getData == undefined || getData == null) {
        var data = event.previousContainer.data[event.previousIndex]; //DropIndexData[event.previousIndex];
        if(data.length > 1){
          if(event.currentIndex > event.previousIndex)
          {
            fieldID = data[data.length - 1].fieldID;
            previousindex= data[data.length - 1].position;
          }
          else {
            fieldID = data[1].fieldID;
          }

        } else{
          fieldID = data.fieldID;
        }
      } else {
        var data = DropIndexData[event.previousIndex];
        if(data == undefined){
          fieldID = getData.fieldID;
        }
        else{
          fieldID = data.fieldID;
        }
      }
    }

    this.reorderPositionVm.folderID = this.folderId;
    this.reorderPositionVm.fieldID = fieldID;//getData.fieldID;
    if (this.subFolderID == undefined) {
      this.subFolderID = 0;
    }
    this.reorderPositionVm.subFolderID = this.subFolderID;//this.subFolderID;
    this.reorderPositionVm.previousPosition = previousindex;//getData.position;//event.previousIndex;
    this.reorderPositionVm.currectPosition = currentindex;//DropIndexData.position;//event.currentIndex;
    this.reorderPositionVm.userID = this.currentUser.UID;
    this.reorderPositionVm.databaseID = Number(this.databaseId);
    this.reorderPositionVm.organizationID = Number(this.organizationId);
    this.reorderPositionVm.fieldGroupID = fieldGroupID;//getData.fieldGroupID;
    this.reorderPositionVm.isRemove = isRemove;//false;
    this.reorderPositionVm.isGroupMove = isGroupMove;
    this.reorderPositionVm.fieldData = reorderedFieldArray;
    this.reorderPositionVm.OfficeIDList=this.OfficeIDList;
    this.reorderPositionVm.officeID=this.myOfficeID;
    this.settingsService.ReorderFieldPostion(this.reorderPositionVm).subscribe(response => {
      if (response != undefined) {
        this.updateFieldResponseHolder = response;
        if (this.updateFieldResponseHolder.status == this.statusConst.statusSuccess) {
          this.subFolderID;
          this.getAllFields(this.subFolderID);
          this.dragdata=null;
        }
        else {
          this.getAllFields(this.subFolderID);
          this.toastr.error(this.updateFieldResponseHolder.message, '', {
            timeOut: 3000,
          });
        }
      }
    });
  }

  drop(event: CdkDragDrop < string[] > ) {

    let previousContainerData: any = event.previousContainer.data;
    let currentContainerData: any = event.container.data;

    // if ((previousContainerData[event.previousIndex] !== undefined &&  previousContainerData[event.previousIndex]|| (currentContainerData[event.currentIndex] !== undefined && currentContainerData[event.currentIndex]==1))) {
    //   return;
    // }

    // if (previousContainerData[event.previousIndex].fieldName === 'Name' || currentContainerData[event.currentIndex].fieldName === 'Name' || previousContainerData[event.previousIndex].fieldName === 'Type' || currentContainerData[event.currentIndex].fieldName === 'Type') {
    //   return;
    // }

    if (this.checkIfGroupDropedInsideGroup(event)) {
      return;
    }

    if (event.previousContainer === event.container) {
      event.currentIndex = this.checkIndex(event);
      //this.Reorder(event);
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      // this.Reorder(event);
      event.currentIndex = this.checkIndex(event);
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }

    let currentArray: any = [];
    currentArray = event.container.data;
   // if (event.container.data.length != this.drapDropList.length) {
      currentArray = this.drapDropList;
   // }

    let dbArray: any = [];
    currentArray.forEach(e => {
      if (e.length == undefined) {
        if (e.position >0)
            dbArray.push({
              fieldID: e.fieldID,
              fieldName: e.fieldName,
              fieldGroupID: null,
              position: e.position,
            });
      } else {
        let groupEle = e.find(m => m.fieldID == 0);
        let grpElements = e.filter(m => m.fieldID != 0);
        grpElements.forEach(ie => {
          if (ie.position >0)
              dbArray.push({
                fieldID: ie.fieldID,
                fieldName: ie.fieldName,
                fieldGroupID: groupEle != undefined ? groupEle.fieldGroupID : 0,
                position: ie.position
              });
          });
        }
    });

    for (let index = 0; index < dbArray.length; index++) {
      dbArray[index].position = index+1;
    }

    this.Reorder(event,dbArray);
  }

  // checkIfGroupDropedInsideGroup(event: CdkDragDrop<string[]>): boolean {
  //   var previousContainer: any[] = event.previousContainer.data;
  //   var currentContainer: any[] = event.container.data;
  //   var IsPreviousGroup = false; var IsCurrentGroup = false;
  //   if (this.isArray(previousContainer[event.previousIndex])) { IsPreviousGroup = true; }
  //   if (this.isArray(currentContainer[0])) {
  //     IsCurrentGroup = false;
  //   } else {
  //     // if (currentContainer[0].fieldName == null) IsCurrentGroup = true;
  //     // else IsCurrentGroup = false;
  //   }
  //   // if (IsPreviousGroup && currentContainer[0].fieldName == null && IsCurrentGroup) { return true; }
  //   return false;
  // }


  checkIfGroupDropedInsideGroup(event: CdkDragDrop<string[]>): boolean {
    var previousContainer: any[] = event.previousContainer.data;
    var currentContainer: any[] = event.container.data;
    var IsPreviousGroup = false; var IsCurrentGroup = false;
    if (this.isArray(previousContainer[event.previousIndex])) { IsPreviousGroup = true; }
    if (this.isArray(currentContainer[0])) {
      IsCurrentGroup = false;
    } else {
      if (currentContainer[0].fieldName == null) IsCurrentGroup = true;
      else IsCurrentGroup = false;
    }
     if (IsPreviousGroup && currentContainer[0].fieldName == null && IsCurrentGroup) { return true; }
    return false;
  }

  checkIndex(event: any): number {
    var IsCurrentGroup = false;
    if (this.isArray(event.container.data[0])) {
      IsCurrentGroup = false;
    } else {
      if (event.container.data[0].fieldName == null) IsCurrentGroup = true;
      else IsCurrentGroup = false;
    }
    let index = 0;
    return index = event.currentIndex == 0 && IsCurrentGroup ? 1 : event.currentIndex;
  }

  isArray(item: any): boolean {
    return Array.isArray(item);
  }

  getElementValue(values: any) {
    this.dragdata = values;
  }

  public onDragEntered(event: CdkDragEnter) {
    this.enforceDragToSelf(event.container);
  }

  public onDragStarted(event: CdkDragStart) {
    this.enforceDragToSelf(event.source.dropContainer);
  }

  private enforceDragToSelf(dl: CdkDropList) {
    const siblings = dl.connectedTo as CdkDropList<any>[];
    const ref = dl._dropListRef;
    asapScheduler.schedule(() => {
      ref.connectedTo(siblings.map(list => list._dropListRef));
    });
  }

  visibleIndex = -1;
  showSubItem(ind: number) {
    if (this.visibleIndex === ind) {
      this.visibleIndex = -1;
    } else {
      this.visibleIndex = ind;
    }
  }

  values: any;
  onChange(event: any, item: { FieldGroupID: number; }[]) {
    this.values = event.target.value;
    if (this.values == "") {
      this.toastr.warning("Group name can not be blank.", '', {
        timeOut: 3000,
      });
    }
    if (event != undefined && this.values != "") {
      this.EditGroupModel.fieldGroupID = item[0].FieldGroupID;
      this.EditGroupModel.groupName = this.values;
      this.EditGroupModel.organizationID = Number(this.organizationId);
      this.EditGroupModel.folderID = this.folderId;
      this.EditGroupModel.officeID = this.myOfficeID;
      this.EditGroupModel.OfficeIDList = this.OfficeIDList;
      this.settingsService.renameGroup(this.EditGroupModel).subscribe(response => {
        if (response != undefined) {
          this.getSubFolderFieldsListResponseHolder = response;
          if (this.getSubFolderFieldsListResponseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success("Group renamed successfully.", '', {
              timeOut: 3000,
            });
            this.getAllFields(this.subFolderID);
          }
        }
      });
    }
  };


  createField(message: boolean, value: any) {
    if(this.folderId != undefined) {
     this._dataSharingService.sendSelectedFolderIdInSetting(this.folderId);
      this.openSlide.emit(message);
    } else {
           this.toastr.info("Please select a sub Folder.", '', {
             timeOut: 3000,
           });
         }
  }

  closecreateField(message: boolean) {
    this.showSidePanel = message;
  }

  editField(message: boolean, value: any, fieldFolderType: any) {
    this.openEditSlide.emit(message)
    this.commonService.setFieldData(value, fieldFolderType);
  }

  openDialogWithRef(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef);
    this.SubFolderButton=false;
  }

  openDialogWithoutRef() {
    this.dialog.open(this.secondDialog);
  }

  getSubFolderList() {
    this.addSubFolderVM.folderID = this.folderId;
    this.addSubFolderVM.userID = this.currentUser.UID;
    this.addSubFolderVM.databaseID = Number(this.databaseId);
    this.addSubFolderVM.organizationId = Number(this.organizationId);
    this.addSubFolderVM.OfficeIDList=this.OfficeIDList;
    this.addSubFolderVM.officeID = this.myOfficeID;
    this.settingsService.getSubFolderList(this.addSubFolderVM).subscribe(response => {
      if (response != undefined) {
        this.getSubFolderListResponseHolder = response;
        if (this.getSubFolderListResponseHolder.status == this.statusConst.statusSuccess) {
          this.subFolderList = this.getSubFolderListResponseHolder.data;
          if(this.subFolderList) {
            this.subFolderList.forEach(e => {
              if(e.isActive) {
               e.folderName=e.folderName +' (Active)';
              } else {
                e.folderName=e.folderName +' (InActive)';
              }
            });
          }
        }
      }
    });
  }

  getSubFolderListForDuplicate() {
    this.addSubFolderVM.folderID = this.folderId;
    this.addSubFolderVM.userID = this.currentUser.UID;
    this.addSubFolderVM.databaseID = Number(this.databaseId);
    this.addSubFolderVM.organizationId = Number(this.organizationId);
    this.addSubFolderVM.OfficeIDList=this.OfficeIDList;
    this.addSubFolderVM.officeID = this.myOfficeID;
    this.settingsService.getSubFolderList(this.addSubFolderVM).subscribe(response => {
      if (response != undefined) {
        this.getSubFolderListResponseHolder = response;
        if (this.getSubFolderListResponseHolder.status == this.statusConst.statusSuccess) {
          this.subFolderListCheck = this.getSubFolderListResponseHolder.data;
        }
      }
    });
  }


  deleteFieldDialog(data: { fieldID: number; }, fieldFolderType: number) {
    const message = `Are you sure you want to delete this field?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          this.deleteModel.userID = this.currentUser.UID;
          this.deleteModel.databaseID = Number(this.databaseId);
          this.deleteModel.fieldID = data.fieldID;
          this.deleteModel.fieldFolderType = fieldFolderType;
          this.deleteModel.OfficeIDList=this.OfficeIDList;
          this.deleteModel.officeID = this.myOfficeID;
          const result = await this.settingsService.deleteField(this.deleteModel).toPromise();
          this.deleteResponseHolder = result;
          this.loaderService.hide();
          if (this.deleteResponseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success("Field deleted successfully.", '', {
              timeOut: 3000,
            });
            this.getAllFields(this.subFolderID);
            return result;
          } else {
            this.loaderService.hide();
            this.toastr.error(this.deleteResponseHolder.message, '', {
              timeOut: 3000,
            });
          }
        } else {
          this.loaderService.hide();
          this.toastr.error(this.deleteResponseHolder.message, '', {
            timeOut: 3000,
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  DeleteGroup(item: any) {
    this.DeleteGroupDialog(item);
  }

  DeleteGroupDialog(item: { FieldGroupID: number; }[]) {
    const message = `Are you sure you want to delete this group?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });

    dialogRef.beforeClosed().subscribe(async dialogResult => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          this.FieldGroupID = item[0].FieldGroupID;
          const result = await this.settingsService.deleteGroup(this.FieldGroupID).toPromise();
          this.deactivateResponseHolder = result;
          this.loaderService.hide();
          if (this.deactivateResponseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success("Group deleted successfully.", '', {
              timeOut: 3000,
            });
            this.getAllFields(this.subFolderID);
            return result;
          } else {
            this.loaderService.hide();
            this.toastr.error(this.deactivateResponseHolder.message, '', {
              timeOut: 3000,
            });
          }
        } else {
          this.loaderService.hide();
          this.toastr.error(this.deactivateResponseHolder.message, '', {
            timeOut: 3000,
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  deactivateField(fieldDetails: any, status: any) {
    this.deactivateFieldDialog(fieldDetails, status);
  }

  deactivateFieldDialog(data: { fieldID: number; }, status: boolean) {
    var message: string;
    if (status == true) {
      message = `Are you sure you want to activate this field?`;
    } else {
      message = `Are you sure you want to deactivate this field?`;
    }
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });

    dialogRef.beforeClosed().subscribe(async dialogResult => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          this.deactivateModel.userID = this.currentUser.UID;
          this.deactivateModel.organizationID = Number(this.organizationId);
          this.deactivateModel.databaseID = Number(this.databaseId);
          this.deactivateModel.fieldID = data.fieldID;
          this.deactivateModel.folderID = this.folderId;
          if (this.subFolderID == undefined) {
            this.subFolderID = 0;
          }
          this.deactivateModel.subFolderID = this.subFolderID;//0;
          this.deactivateModel.isActive = status; //false;
          this.deactivateModel.requestType = 0;
          this.deactivateModel.OfficeIDList=this.OfficeIDList;
          this.deactivateModel.officeID=this.myOfficeID;
          const result = await this.settingsService.deactivateFields(this.deactivateModel).toPromise();
          this.deactivateResponseHolder = result;
          this.loaderService.hide();
          if (this.deactivateResponseHolder.status == this.statusConst.statusSuccess) {
            if (status == true){
              this.toastr.success('Field activated successfully.', '', {
                timeOut: 3000,
              });
            } else{
              this.toastr.success('Field deactivated successfully.', '', {
                timeOut: 3000,
              });
            }
            this.getAllFields(this.subFolderID);
            return result;
          } else {
            this.loaderService.hide();
            this.toastr.error(this.deactivateResponseHolder.message, '', {
              timeOut: 3000,
            });
          }
        } else {
          this.loaderService.hide();
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  changedToggle(item: { fieldID: number; }, event: { checked: boolean; }) {
    if (event != undefined) {
      this.deactivateModel.userID = this.currentUser.UID;
      this.deactivateModel.organizationID = Number(this.organizationId);
      this.deactivateModel.databaseID = Number(this.databaseId);
      this.deactivateModel.fieldID = item.fieldID;
      this.deactivateModel.folderID = this.folderId;
      if (this.subFolderID == undefined) {
        this.subFolderID = 0;
      }
      this.deactivateModel.subFolderID = this.subFolderID;//0;
      this.deactivateModel.isRequired = event.checked; //false;
      this.deactivateModel.requestType = 1;
      this.deactivateModel.OfficeIDList=this.OfficeIDList;
      this.deactivateModel.officeID=this.myOfficeID;
      this.settingsService.deactivateFields(this.deactivateModel).subscribe(response => {
        if (response != undefined) {
          this.getSubFolderFieldsListResponseHolder = response;
          if (this.getSubFolderFieldsListResponseHolder.status == this.statusConst.statusSuccess) {
            this.getAllFields(this.subFolderID);
          }
        }
      });
    }
  }

  SubFolderButton:boolean=false;

  onSearchChange(searchValue: string){
   if(searchValue!=null && searchValue!="" && searchValue!=undefined){
     this.SubFolderButton=true;
   }else{
    this.SubFolderButton=false;
   }
  }

  createSubFolder(value: string) {
    this.SubFolderButton=false;
    if (value == "" || value == null) {
      this.toastr.warning("please enter "+this.typename+" type.", '', {
        timeOut: 3000,
      });
      return;
    }

    var checkDuplicate= this.subFolderListCheck.filter(x => x.folderName.toLowerCase() === value.replace(/\s/g, "").toLowerCase());
     if(checkDuplicate.length > 0){
      this.toastr.warning("Name allready Exist", '', {
        timeOut: 3000,
      });
     }else{
      this.createSubFolderModel.userID = this.currentUser.UID;
      this.createSubFolderModel.folderName = value;
      this.createSubFolderModel.parentID = this.folderId;
      this.createSubFolderModel.databaseID = Number(this.databaseId);
      this.createSubFolderModel.folderType = 1;
      this.createSubFolderModel.organizationID = Number(this.organizationId);
      this.createSubFolderModel.OfficeIDList=this.OfficeIDList;
      this.createSubFolderModel.officeID=this.myOfficeID;
      this.settingsService.createSubFolder(this.createSubFolderModel).subscribe(response => {
        if (response != undefined) {
          this.createSubFolderResponseHolder = response;
          if (this.createSubFolderResponseHolder.status == this.statusConst.statusSuccess) {
            this.close();
            this.getSubFolderListForDuplicate();
            this.getSubFolderList();
            this.toastr.success("Type created successfully.", '', {
              timeOut: 3000,
            });
          }
          else {
            this.toastr.warning(this.createSubFolderResponseHolder.message, '', {
              timeOut: 3000,
            });
          }
        }else{
        }
      });
     }
  }


  getSubFolderFields(event: { value: number; }) {
    if (event != undefined) {
      this.loaderService.show();
      this.subFolderID = event.value;
      this.expandAdditionalField = true;
      this.showAdditionalField = true;
      this.getSubFolderFieldsModel.userID = this.currentUser.UID;
      this.getSubFolderFieldsModel.organizationID = Number(this.organizationId);
      this.getSubFolderFieldsModel.databaseID = Number(this.databaseId);
      this.getSubFolderFieldsModel.folderID = this.folderId;
      this.getSubFolderFieldsModel.subFolderID = event.value;
      this.getSubFolderFieldsModel.OfficeIDList=this.OfficeIDList;
      this.getSubFolderFieldsModel.officeID=this.myOfficeID;
      this.settingsService.getAllFieldsCore(this.getSubFolderFieldsModel).subscribe(response => {
        if (response != undefined) {
          this.loaderService.hide();
          this.getSubFolderFieldsListResponseHolder = response;
          if (this.getSubFolderFieldsListResponseHolder.status == this.statusConst.statusSuccess) {
            this.fieldsList = this.getSubFolderFieldsListResponseHolder.data.activeFields;//.filter(s => s.isActive == true);
            this.fieldsList = this.fieldsList.filter(s => s.fieldTypeName != 'Image');
            this.DeactivatefieldsList = this.getSubFolderFieldsListResponseHolder.data.inActiveFields;//.filter(s => s.isActive == false);
            this.fieldListFolderWise = this.fieldsList;
            this.drapDropList = this.displayDragAndDropList(this.fieldListFolderWise);
            this.change.detectChanges();
            this.refreshDLS();
          }
          else {
            this.loaderService.hide();
          }
        }
      });
    }
  }


  close() {
    this.OfficeOrgList=[];
    this.fieldsforImport=[];
    this.subFolderName = null;
    this.dialog.closeAll();
  }

  addEditGroup() {
    this.loaderService.show();
    this.addEditGroupVm.OrganizationID = Number(this.organizationId);
    this.addEditGroupVm.FolderID = this.folderId;
    this.addEditGroupVm.OfficeIDList=this.OfficeIDList;
    this.addEditGroupVm.officeID=this.myOfficeID;
    this.settingsService.addEditGroup(this.addEditGroupVm).subscribe(response => {
      if (response != undefined) {
        this.updateFieldResponseHolder = response;
        if (this.updateFieldResponseHolder.status == this.statusConst.statusSuccess) {
          this.getAllFields(this.subFolderID);
          this.loaderService.hide();
        }
        else {
          this.getAllFields(this.subFolderID);
          this.loaderService.hide();
          this.toastr.error(this.updateFieldResponseHolder.message, '', {
            timeOut: 3000,
          });
        }
      }
      else {
        this.getAllFields(this.subFolderID);
        this.loaderService.hide();
        this.toastr.error(this.updateFieldResponseHolder.message, '', {
          timeOut: 3000,
        });
      }
    });
  }

  systemFeildsList:any=[]=[];
  fieldID:number=0;
  fieldName:string="";
  SynonymsButton:boolean=true;

  openDialogSynonyms(templateRef: TemplateRef<any>,item:any) {
    this.SynonymsButton=true;
    this.systemFeildsList=[];
    var arraysynonyms:any=[]=[];
    var defaultSynonyms:any=[]=[];
    this.dialog.open(templateRef, {
    });
   this.fieldID= item.fieldID;
   this.fieldName= item.fieldName;
  //  if(item.defaultSynonyms!=""){
  //   defaultSynonyms = item.defaultSynonyms.split(',');
  //   if(defaultSynonyms.length>0){
  //     defaultSynonyms.forEach(e => {
  //      var obj={         
  //        fieldID:this.randomId(),
  //        value:e,
  //        isDeleted:false,
  //      }
  //      this.systemFeildsList.push(obj);
  //     }); 
  //  }
  //  }
   if(item.synonyms!=""){
     arraysynonyms = item.synonyms.split(',');
     if(arraysynonyms.length>0){
       arraysynonyms.forEach(e => {
        var obj={         
          fieldID:this.randomId(),
          value:e,
          isDeleted:true,
        }
        this.systemFeildsList.push(obj);
       }); 
    }
   }
  
  }

  randomId() {
    return Math.random();
  }

  addSynonyms(){
    this.SynonymsButton=false;
    var obj={
      fieldID:this.randomId(),
      value:"",
      isDeleted:true,
    }
    this.systemFeildsList.push(obj);
  }

  removesystemField(item){
    let removeIndex = this.systemFeildsList.findIndex((itm) => itm.fieldID === item.fieldID);
    if (removeIndex !== -1) this.systemFeildsList.splice(removeIndex, 1);    
     this.SynonymsButton=false;
   }

     ontextChange(val:any){
      this.SynonymsButton=false;
    }

  //  get rows(): FormArray {
  //   return this.form.get('rows') as FormArray;
  // }
  
  // newRow(): FormGroup {
  //   return this.formBuilder.group({
  //     value: [''] // Add validators as required
  //   });
  // }

  // addRow() {
  //   this.rows.push(this.newRow());
  // }

  // removeRow(index: number) {
  //   this.rows.removeAt(index);
  // }

  menuModulesList: any = [] = [];
  fieldList: any = [] = [];

   saveSynonyms(){
    var Selecteddata=[];
    var newsystemFeildsList:any=[]=[];
    var cType;
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    Selecteddata= this.menuModulesList.filter(x => x.orgModuleName == this.typename);
    if (Selecteddata.length > 0) {     
      this.folderId=Selecteddata[0].folderID;
      if(Selecteddata[0].mainModuleName=="Core"){
        cType=1;
      }
      if(Selecteddata[0].mainModuleName=="Contact"){
        cType=2;
      }
      if(Selecteddata[0].mainModuleName=="Company"){
        cType=3;
      }
    }
    this.fieldList=[];
    newsystemFeildsList = this.systemFeildsList.filter(x=>x.isDeleted==true);
    //this.systemFeildsList=this.systemFeildsList.filter(x=>x.isDeleted==true);
    newsystemFeildsList=newsystemFeildsList.filter(x=>x.value!="");
    if (newsystemFeildsList.length > 0) {    
      for (let i = 0; i < newsystemFeildsList.length; i++) {
        const values = newsystemFeildsList[i].value;
        this.fieldList.push(values);
      }
    }else{
      // this.toastr.warning('Please Enter Synonyms Field.', '', {
      //   timeOut: 3000,
      // });
      // return;
    }

    // if(this.SuperAdminAdd==true){
    //   var obj={
    //    folderID : this.folderId,
    //    cType:cType,
    //    field:{
    //     fieldID: this.fieldID,
    //     synonyms: this.fieldList.join(',')
    //     },
    //    userID : this.currentUser.UID,
    //    databaseID : Number(this.databaseId),
    //    organizationId : Number(this.organizationId),
    //    officeIDList:this.OfficeIDList,
    //    officeID : this.myOfficeID
    //   }
    //   //return;
    //   this.settingsService.updateFieldDefaultSynonyms(obj).subscribe(response => {
    //     if (response != undefined) {
    //       this.getSubFolderListResponseHolder = response;
    //       if (this.getSubFolderListResponseHolder.status == this.statusConst.statusSuccess) {
    //         this.toastr.success('Synonyms Field save successfully.', '', {
    //           timeOut: 3000,
    //         });
    //         this.getAllFields(this.subFolderID);
    //         this.close();
    //       }
    //     }
    //   });
    // }

   // if(this.SuperAdminAdd==false){
      var obj={
       folderID : this.folderId,
       cType:cType,
       field:{
        fieldID: this.fieldID,
        synonyms: this.fieldList.join(',')
        },
       userID : this.currentUser.UID,
       databaseID : Number(this.databaseId),
       organizationId : Number(this.organizationId),
       officeIDList:this.OfficeIDList,
       officeID : this.myOfficeID
      }   
      this.loaderService.show();
      this.settingsService.updateFieldSynonyms(obj).subscribe(response => {
        if (response != undefined) {
          this.loaderService.hide();
          this.getSubFolderListResponseHolder = response;
          if (this.getSubFolderListResponseHolder.status == this.statusConst.statusSuccess) {
             this.loaderService.hide();
            this.toastr.success('Synonyms Field save successfully.', '', {
              timeOut: 3000,
            });
            this.getAllFields(this.subFolderID);
            this.close();
          }else{
             this.loaderService.hide();
          }
        }else{
           this.loaderService.hide();
        }
          
      });
   // }
   }

   
  organizationListShow:boolean=false;
  organizationList: any[] = [];

   pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    organizationID:0,
    officeID:0
  };
  pageIndex: any;
  pageSize: any;
  organizationResponseHolder: any;
  totalCount: number = 0;
  ImportFieldstoOtherOrg:boolean=false;
  showImportButton :boolean=false;
  OfficeOrgList:any=[]=[];
  fieldsforImport:any=[]=[];

  openDialogImport(templateRef: TemplateRef<any>) {
    this.showImportButton=false;    
    this.organizationList=[];
    this.OfficeOrgList=[];
    this.getOraganizationList(this.pageModelData); 
    this.dialog.open(templateRef,{
      panelClass: 'custom-modalbox'
    });
  }

  getOraganizationList(pageData: any) {
  
    // var myOfficeID;
    //   this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));   
    //     if(this.rolesAsssign.length > 0){
    //       var role=[];
    //        // roleLevel:1 (Super admin), roleLevel:2 (Organization Admin), roleLevel:3 (Office Admin),
    //        // roleLevel:11 (User)
          
    //      role= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OfficeAdmin);
    //      if(role.length > 0){
    //       myOfficeID=this.myOfficeID;
    //       this.officeAdmin=true;        
    //      } 
    
    //       role= this.rolesAsssign.filter((m) => m.roleLevel ==  RoleLevel.OrganizationAdmin);
    //       if(role.length > 0){
    //        myOfficeID=0;         
    //        this.officeAdmin=false;
    //      }
         
    //      role= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);
    //        if(role.length > 0){
    //         myOfficeID=0;           
    //        // this.getOraganizationList(this.pageModelData);
    //        // return;
    //       }
    //     }
    this.loaderService.show();    
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.organizationID = 0;//Number(this.organizationId);
    this.pageModelData.officeID = 0;//myOfficeID;
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    this.settingsService.getOffices(this.pageModelData).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.organizationResponseHolder = response;
        if (this.organizationResponseHolder.status == this.statusConst.statusSuccess) {          
          this.organizationList=this.organizationResponseHolder.data.organizations;
          if(this.organizationList.length>0){

            this.expanded = {}; // reset
             this.organizationList.forEach(row => {
             this.expanded[row.officeName] = false;  // all collapsed by default
            });

           this.organizationList.forEach(org => {
             org.isChecked = false; // for parent org office
              if (Array.isArray(org.offices)) {
               org.offices.forEach(office => {
               office.isChecked = false;
              });
             }
           });               
          this.organizationListShow=false;
          }else{
            this.organizationListShow=true;
          }         
          this.loaderService.hide();
        }else{
          this.organizationList = [];
          this.loaderService.hide();
        }
      }else{
        this.organizationList =[];
        this.loaderService.hide(); 
      }
    });
  }

  isRowClickable(rowIndex: number) {   
    return this.organizationList[rowIndex].offices && this.organizationList[rowIndex].offices.length > 0;
  }

  checkFeilds(event:MatCheckboxChange,item){
    if(event.checked==true){
      this.ImportFieldstoOtherOrg=true;
      this.fieldsforImport.push(item.fieldID);
    }else{     
      this.fieldsforImport = this.fieldsforImport.filter((x) => x !== item.fieldID);
      if(this.fieldsforImport.length>0){
        this.ImportFieldstoOtherOrg=true;
      }else{
        this.ImportFieldstoOtherOrg=false;
      }
    }
  }

  //  checkFeildsGroup(event:MatCheckboxChange,item){
  //   if(event.checked==true){
  //     this.ImportFieldstoOtherOrg=true;
  //   }
  // }
  
  
  checkFeildsinnerItem(event:MatCheckboxChange,item){
   if(event.checked==true){
      this.ImportFieldstoOtherOrg=true;
      this.fieldsforImport.push(item.fieldID);
    }else{     
      this.fieldsforImport = this.fieldsforImport.filter((x) => x !== item.fieldID);
      if(this.fieldsforImport.length>0){
        this.ImportFieldstoOtherOrg=true;
      }else{
        this.ImportFieldstoOtherOrg=false;
      }
    }
  }

  checkOrgization(event:MatCheckboxChange,item){
    if(item.offices==null){
      item.offices=[];
    }
    if(event.checked==true){ 
      if(item.offices.length>0){
        if(Array.isArray(item.offices)) {
         item.offices.forEach(office => {
         office.isChecked = true;
          this.showImportButton=true;
          var obj={
           orgID: office.organizationID,
           officeID: office.officeID
          }
         this.OfficeOrgList.push(obj);
        });
       }
      }else{
         var obj={
           orgID: item.organizationID,
           officeID: item.officeID
          }
         this.OfficeOrgList.push(obj);
      } 
    }else{
      
      this.OfficeOrgList = this.OfficeOrgList.filter((x) => x.orgID !== item.organizationID || x.officeID !== item.officeID);

      //  if(item.offices.length>0){
      //   if(Array.isArray(item.offices)) {
      //    item.offices.forEach(office => {
      //    office.isChecked = false;       
      //   //  Remove matching object from OfficeOrgList
      //    this.OfficeOrgList = this.OfficeOrgList.filter((x) => x.orgID !== office.organizationID || x.officeID !== office.officeID);
      //    });
      //   }
      //  }  else{
      //   this.OfficeOrgList = this.OfficeOrgList.filter((x) => x.orgID !== item.organizationID || x.officeID !== item.officeID);
      //  }    
    }
   
     if(this.OfficeOrgList.length>0){
       this.showImportButton=true;
       }else{
       this.showImportButton=false;
    }
  }

  checkOffice(event:MatCheckboxChange,item){
    if(event.checked==true){
      this.showImportButton=true;
      var obj={
        orgID: item.organizationID,
        officeID: item.officeID
      }
      this.OfficeOrgList.push(obj);
    }else{
      // Remove matching object from OfficeOrgList
      this.OfficeOrgList = this.OfficeOrgList.filter((x) => x.orgID !== item.organizationID || x.officeID !== item.officeID);
      if(this.OfficeOrgList.length>0){
        this.showImportButton=true;
      }else{
        this.showImportButton=false;
      }
    }
  }

  ImportSelectedFieldsForOtherOffices(){ 
     // Remove duplicates based on officeID and orgID
    const uniqueOfficeOrgList = this.OfficeOrgList.filter((item, index, self) =>
    index === self.findIndex(t => t.officeID === item.officeID && t.orgID === item.orgID));

     var reqModel={
       originOrganizationID:Number(this.organizationId),
       originOfficeID: this.myOfficeID,
       userID : this.currentUser.UID,
       offices: uniqueOfficeOrgList,//this.OfficeOrgList,
       fields:this.fieldsforImport,     
      }
      //return;
      this.settingsService.importSelectedFieldsForOtherOffices(reqModel).subscribe(response => {
        if (response != undefined) {
          this.getSubFolderListResponseHolder = response;
          if (this.getSubFolderListResponseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success('Imported Selected Fields For Other Offices successfully.', '', {
              timeOut: 3000,
            });
            this.OfficeOrgList=[];
            this.fieldsforImport=[];
            this.getAllFields(this.subFolderID);
            this.close();
          }
        }
      });    
    }

}
